<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <div>
        <h4 class="earth-color">CHECKED OUT BOOKINGS</h4>
        <div class="title-decoration"></div>
      </div>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-container>
      <v-layout row wrap>
        <v-flex lg12 md12 sm12 xs12>
          <v-layout row wrap>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog"
                  persistent
                  v-model="modal1"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="calendar.start_date"
                >
                  <v-text-field
                    slot="activator"
                    label="Start Date"
                    v-model="calendar.start_date"
                    readonly
                    class="futuristic-input"
                  ></v-text-field>
                  <v-date-picker v-model="calendar.start_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn
                      :depressed="true"
                      flat
                      color="#e84118"
                      @click="modal1 = false"
                      class="futuristic-btn"
                    >Cancel</v-btn>
                    <v-btn
                      :depressed="true"
                      flat
                      color="#587e27"
                      @click="$refs.dialog.save(calendar.start_date)"
                      class="futuristic-btn"
                    >OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <v-container>
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal2"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="calendar.end_date"
                >
                  <v-text-field
                    slot="activator"
                    label="End Date"
                    v-model="calendar.end_date"
                    readonly
                    class="futuristic-input"
                  ></v-text-field>
                  <v-date-picker
                    :min="calendar.start_date"
                    v-model="calendar.end_date"
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      :depressed="true"
                      flat
                      color="#e84118"
                      @click="modal2 = false"
                      class="futuristic-btn"
                    >Cancel</v-btn>
                    <v-btn
                      :depressed="true"
                      flat
                      color="#587e27"
                      @click="$refs.dialog1.save(calendar.end_date)"
                      class="futuristic-btn"
                    >OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-container>
            </v-flex>
            <v-flex lg4 md4 sm12 xs12>
              <br />
              <v-btn
                :depressed="true"
                color="#587e27"
                @click="getData()"
                block
                :loading="this.$store.state.LoadingStore.loading"
                class="futuristic-btn"
              >Get Selected CHECKING IN Dates</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="columns"
      :items="checkedOut"
      :search="search"
      :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
      class="futuristic-table"
    >
      <v-progress-linear
        slot="progress"
        color="#587e27"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td data-label="Ref">
          <router-link
            :to="{
              name: 'Booking',
              params: { booking_id: props.item.booking_public_id },
            }"
            ><a class="futuristic-link"
              ><u>{{ props.item.booking_ref_code }}</u></a
            ></router-link
          >
        </td>
        <td data-label="Client Name">{{ props.item.booking_done_by }}</td>
        <td data-label="Booking Type">{{ props.item.booking_type }}</td>
        <td data-label="Check In">{{ formated_date(props.item.booking_check_in_date) }}</td>
        <td data-label="Check Out">{{ formated_date(props.item.booking_check_out_date) }}</td>
        <td data-label="Number of Guests">{{ props.item.guest_total }}</td>
        <td data-label="Action">
          <v-btn
            :depressed="true"
            color="#f1c40f"
            small
            @click="openBooking(props.item.booking_public_id)"
            class="futuristic-btn"
          >View Booking</v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      modal1: false,
      modal2: false,
      columns: [
        {
          text: "Ref",
          value: "booking_ref_code",
        },
        {
          text: "Client Name",
          value: "name",
        },
        {
          text: "Booking Type",
          value: "booking_type",
        },
        {
          text: "Check In",
          value: "check_in",
        },
        {
          text: "Check Out",
          value: "check_out",
        },
        {
          text: "Number of Guests",
          name: "guest_total",
        },
        {
          text: "Action",
          value: "",
        },
      ],
      today: this.$moment.now(),
      calendar: {
        start_date: this.$moment(this.today).format("YYYY-MM-DD"),
        end_date: this.$moment(this.today).add(1, "days").format("YYYY-MM-DD"),
      },
    };
  },
  created() {
    this.$store.dispatch("get_checked_out_bookings", this.calendar);
  },
  methods: {
    openBooking: function (publicId) {
      this.$router.push({
        name: "Booking",
        params: {
          booking_id: publicId,
        },
      });
    },
    viewBooking: function (publicId) {
      this.$router.push({
        name: "Booking",
        params: {
          booking_id: publicId,
        },
      });
    },
    getData: function () {
      this.$store.dispatch("loading_true");
      this.$store.dispatch("get_checked_out_bookings", this.calendar);
    },
  },
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

/* Card Header */
.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

/* Input Fields */
.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

/* Buttons */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Data Table */
.futuristic-table {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-table >>> th {
  color: #587e27;
  font-weight: 600;
}

/* Links */
.futuristic-link {
  color: #587e27;
  text-decoration: none;
  transition: color 0.2s ease;
}

.futuristic-link:hover {
  color: #1b5e20;
}

/* Alerts */
.futuristic-alert {
  border-radius: 8px;
  background: #fff5f5;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }
}
</style>